module.exports = __webpack_public_path__ + "img/icon-good-round@3x.2d057467.png";